<template>
<div class="add modal modal--default">
    <div class="modal__panel" :class="showAddActivityModal ? 'modal__panel--in' : 'modal__panel--out'">
        <div class="modal__logo-wrapper">
            <div class="modal__logo"></div>
            <!-- <div class="modal__logo-title">Seguro Desk</div> -->
        </div>
        <div class="modal__close" @click="$store.commit('setShowAddActivityModal', false)"></div>
        <div class="add__new">{{ $t(`addCustomerServiceModal.${"title"}`) }}</div>
        <div class="add__title">
            {{ $t(`addCustomerServiceModal.${"subTitle"}`) }}
        </div>
        <div class="customers">
            <div v-if="$checkRolePermission('pendency_create')" class="customer" @click="showAddPendencyModal()">
                <div class="customer__icon customer__icon--pendencies"></div>
                <button class="add__button button button--default">
                    {{ $t(`addCustomerServiceModal.${"pendenciesButton"}`) }}
                </button>
            </div>
            <div v-if="$checkRolePermission('note_create')" class="customer" @click="showAddNotesModal()">
                <div class="customer__icon customer__icon--notes"></div>
                <button class="add__button button button--default">
                    {{ $t(`addCustomerServiceModal.${"notesButton"}`) }}
                </button>
            </div>
            <div v-if="$checkRolePermission('call_create')" class="customer" @click="showAddCallsModal()">
                <div class="customer__icon customer__icon--calls"></div>
                <button class="add__button button button--default">
                    {{ $t(`addCustomerServiceModal.${"callsButton"}`) }}
                </button>
            </div>
            <div class="customer" @click="showAddMandateModal()">
                <div class="customer__icon customer__icon--mandat"><i class="fas fa-file-signature"></i></div>
                <button class="add__button button button--default">
                    {{ $t(`addCustomerServiceModal.${"mandateButton"}`) }}
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
export default {
    name: "AddActivityModal",

    computed: {
        ...mapGetters(["showAddActivityModal"]),
    },

    methods: {
        showAddPendencyModal() {
            this.$store.commit("setShowAddActivityModal", false);
            this.$store.commit("setShowAddPendencyModal", true);

        },

        showAddNotesModal() {
            this.$store.commit("setShowAddActivityModal", false);
            this.$store.commit("setShowAddNotesModal", true);
        },

        showAddCallsModal() {
            this.$store.commit("setShowAddActivityModal", false);
            this.$store.commit("setShowAddCallsModal", true);
        },

        showAddMandateModal() {
            this.$store.commit("setShowAddActivityModal", false);
            this.$store.commit("setShowAddMandateModal", true);
        }
    },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_add-panel-modal.scss";
</style>
